// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSystemConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var actions = require('../Izenda.PermissionActions');
  var SECTION = require('logic/data/Izenda.PermissionConstants').SECTION;
  var EventsUtils = require('EventUtils');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  var CheckboxAllPermission = require('./Izenda.CheckboxAllPermission');
  const { isNil, get } = require('lodash/fp');

  var PermissionSystemConfiguration = React.createClass({
    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.systemConfiguration = this.props.permission.systemConfiguration;
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var hasScheduleLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Scheduling);
      var systemConfiguration = get('systemConfiguration', tenantDetail);

      return (
        hasScheduleLicense &&
        (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.systemConfiguration)) && (
          <div className={SECTION.SystemConfiguration}>
            <GridLayout className="izenda-GridLayout-Custom">
              <GridLayout.Row className="u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header">
                <GridLayout.Col cols={2}>
                  <a
                    className={this.props.getIconClass('isShowSystemConfiguration')}
                    onClick={this.props.toggle.bind(this, 'isShowSystemConfiguration')}
                  />
                  {localization.getText('COMMON_LABEL_SYSTEM_CONFIGURATION')}
                </GridLayout.Col>
                <GridLayout.Col cols={9}>
                  <CheckboxAllPermission
                    permission={permission}
                    readOnly={this.props.readOnly}
                    section={this.systemConfiguration}
                    tenantPermission={systemConfiguration}
                    tenantDetail={tenantDetail}
                  />
                </GridLayout.Col>
                {permission.isTenantSetup && (
                  <GridLayout.Col cols={1} className="u_textCenter">
                    <Input
                      type="checkbox"
                      indeterminate={this.props.getIndeterminateCommon(this.systemConfiguration)}
                      checked={this.props.getCheckedCommon(this.systemConfiguration.tenantAccess)}
                      onChange={notifyChange(
                        permission.updateTenantAccessParent.bind(permission, this.systemConfiguration),
                        EventsUtils.CHECKBOX
                      )}
                      readOnly={this.props.readOnly}
                    />
                  </GridLayout.Col>
                )}
              </GridLayout.Row>
            </GridLayout>
            {permissionStore.isShowSystemConfiguration &&
              (isNil(tenantDetail) ||
                this.props.checkShowGroupCommon(tenantDetail.systemConfiguration.scheduledInstances)) && (
                <GridLayout className="izenda-GridLayout-Custom">
                  <GridLayout.Row className="u_paddingTop u_paddingBottom">
                    <GridLayout.Col cols={2} className="izenda-PermissionCategory-SubCategory">
                      {localization.getText('PERMISSION_LABEL_SCHEDULED_INSTANCES')}
                    </GridLayout.Col>
                    <GridLayout.Col cols={9}>
                      <Input
                        type="checkbox"
                        readOnly={this.props.readOnly}
                        checked={this.props.getCheckedCommon(this.systemConfiguration.scheduledInstances.value)}
                        onChange={notifyChange(
                          permission.updateData.bind(permission, this.systemConfiguration.scheduledInstances, 'value'),
                          EventsUtils.CHECKBOX
                        )}
                      />
                    </GridLayout.Col>
                    {permission.isTenantSetup && (
                      <GridLayout.Col cols={1} className="u_textCenter">
                        <Input
                          type="checkbox"
                          readOnly={this.props.readOnly}
                          checked={this.props.getCheckedCommon(
                            this.systemConfiguration.scheduledInstances.tenantAccess
                          )}
                          onChange={notifyChange(
                            permission.updateTenantAccess.bind(
                              permission,
                              this.systemConfiguration,
                              this.systemConfiguration.scheduledInstances
                            ),
                            EventsUtils.CHECKBOX
                          )}
                        />
                      </GridLayout.Col>
                    )}
                  </GridLayout.Row>
                </GridLayout>
              )}
          </div>
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionSystemConfiguration);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionSystemConfiguration.jsx